<template>
    <div>
        <ViewVehicle  v-if="!!item" @success="alertSuccess"></ViewVehicle>

        <fleet-table
            title="Users"
            @addVehicle="showVehicleModal"
            ref="table"
        ></fleet-table>
        
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import FleetTable from './FleetTable'
import ViewVehicle from './ViewVehicle'
// import CreateVehicleForm from './CreateVehicleForm'

export default {
    name: 'fleet',
    mixins: [popupMixins, permissionsMixins],
    components: {
        FleetTable,
        ViewVehicle,
    },
    data: () => {
        return {
            item: null,
        }
    },

    methods: {
        alertSuccess(action) {
            console.log("asdasda",action)
            console.log(this.item)
            this.genericToast(
                this.componentName,
                action,
                'success',
                `${name} has been succcessfully ${action.toLowerCase()}`
            )
            //this.doToast('Success', `Item ${action}!`, 'success')
            this.item = null
            this.$refs.table.doSearch()
        },
        showVehicleModal() {
            this.$refs.createVehicle.showModal()
        },
        // created() {
        //     this.doToast('Created!', 'Vehicle Created', 'success')
        //     this.$refs.table.doSearch()
        //     this.$refs.createVehicle.hideModal()
        // },
        handleError(error) {
            this.doToast(this.$translate('error'), error.message, 'danger')
        },
    },
}
</script>
<style></style>
